/* EmmetiStore \u2014 tempi di consegna 1.0.4. Nessuna dipendenza dall'app precedente. */
(function (global) {
  'use strict';
  const DAY = 86400000;
  const TEXTS = {
    it: ['Disponibile', 'consegna per', 'Ordinabile ora', 'spedizione dal', "Non disponibile per l\u2019ordine", 'Seleziona una variante', 'giorni lavorativi'],
    en: ['Available', 'delivery by', 'Order now', 'dispatch from', 'Unavailable to order', 'Select a variant', 'business days'],
    fr: ['Disponible', 'livraison pr\u00e9vue le', 'Commandez maintenant', 'exp\u00e9dition \u00e0 partir du', 'Indisponible \u00e0 la commande', 'S\u00e9lectionnez une variante', 'jours ouvr\u00e9s'],
    de: ['Verf\u00fcgbar', 'Lieferung bis', 'Jetzt bestellbar', 'Versand ab', 'Nicht bestellbar', 'Variante ausw\u00e4hlen', 'Werktage'],
    es: ['Disponible', 'entrega prevista para el', 'P\u00eddelo ahora', 'env\u00edo a partir del', 'No disponible para pedidos', 'Selecciona una variante', 'd\u00edas laborables'],
    pt: ['Dispon\u00edvel', 'entrega prevista para', 'Encomende agora', 'envio a partir de', 'Indispon\u00edvel para encomenda', 'Selecione uma variante', 'dias \u00fateis'],
    nl: ['Beschikbaar', 'bezorging uiterlijk', 'Nu te bestellen', 'verzending vanaf', 'Niet te bestellen', 'Selecteer een variant', 'werkdagen'],
    pl: ['Dost\u0119pny', 'dostawa do', 'Zam\u00f3w teraz', 'wysy\u0142ka od', 'Produkt niedost\u0119pny do zam\u00f3wienia', 'Wybierz wariant', 'dni robocze'],
    ro: ['Disponibil', 'livrare p\u00e2n\u0103 la', 'Comand\u0103 acum', 'expediere \u00eencep\u00e2nd cu', 'Indisponibil pentru comand\u0103', 'Selecteaz\u0103 o variant\u0103', 'zile lucr\u0103toare'],
    sv: ['Tillg\u00e4nglig', 'leverans senast', 'Best\u00e4ll nu', 'skickas fr\u00e5n', 'Kan inte best\u00e4llas', 'V\u00e4lj en variant', 'arbetsdagar'],
    ja: ['\u5728\u5eab\u3042\u308a', '\u304a\u5c4a\u3051\u4e88\u5b9a\u65e5\uff1a', '\u3054\u6ce8\u6587\u53d7\u4ed8\u4e2d', '\u767a\u9001\u958b\u59cb\u4e88\u5b9a\u65e5\uff1a', '\u3054\u6ce8\u6587\u3044\u305f\u3060\u3051\u307e\u305b\u3093', '\u30d0\u30ea\u30a8\u30fc\u30b7\u30e7\u30f3\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044', '\u55b6\u696d\u65e5']
  };
  const TEXT_KEYS = ['available', 'delivery', 'restock', 'dispatch', 'unavailable', 'select', 'days'];
  function objectJSON(value) {
    if (value && typeof value === 'object' && !Array.isArray(value)) return value;
    try { const o = JSON.parse(value || '{}'); return o && typeof o === 'object' && !Array.isArray(o) ? o : {}; } catch (_) { return {}; }
  }
  function validDays(value) {
    if (value === '' || value === null || value === undefined || typeof value === 'boolean') return null;
    const n = Number(value);
    return Number.isInteger(n) && n >= 0 && n <= 365 ? n : null;
  }
  function resolveDays(data, field) {
    const personal = validDays(data.productDays && data.productDays[field]);
    if (personal !== null) return personal;
    const vendor = String(data.vendor || '').trim().toUpperCase();
    const collections = new Set((data.collections || []).map(String));
    const tiers = [[], [], []];
    (data.rules || []).forEach(rule => {
      const days = validDays(rule[field]);
      if (days === null) return;
      const brand = String(rule.brand || '').trim().toUpperCase();
      const collection = rule.collection == null ? '' : String(rule.collection);
      if (brand === vendor && vendor && collection && collections.has(collection)) tiers[0].push(days);
      else if (brand === vendor && vendor && !collection) tiers[1].push(days);
      else if (brand === 'DEFAULT' && !collection) tiers[2].push(days);
    });
    for (const values of tiers) if (values.length) return Math.max(...values);
    const fallback = validDays(data[field === 'in' ? 'fallbackIn' : 'fallbackOut']);
    return fallback === null ? (field === 'in' ? 3 : 6) : fallback;
  }
  function parseDay(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const [y, m, d] = value.split('-').map(Number);
    const date = new Date(Date.UTC(y, m - 1, d));
    return date.getUTCFullYear() === y && date.getUTCMonth() === m - 1 && date.getUTCDate() === d ? date.getTime() : null;
  }
  function iso(day) { return new Date(day).toISOString().slice(0, 10); }
  function romeParts(instant) {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date(instant));
    const p = Object.fromEntries(parts.map(x => [x.type, x.value]));
    return { day: parseDay(`${p.year}-${p.month}-${p.day}`), minutes: Number(p.hour) * 60 + Number(p.minute) };
  }
  function easter(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return Date.UTC(year, Math.floor(n / 31) - 1, n % 31 + 1);
  }
  function calendar(config) {
    const closures = String(config.closures || '').split(/[\s,;]+/).map(parseDay).filter(x => x !== null);
    const closed = new Set(closures);
    return function working(day) {
      const date = new Date(day), week = date.getUTCDay();
      if (week === 0 || week === 6 || closed.has(day)) return false;
      if (config.holidays !== false) {
        const md = iso(day).slice(5), y = date.getUTCFullYear();
        if (['01-01', '01-06', '04-25', '05-01', '06-02', '08-15', '11-01', '12-08', '12-25', '12-26'].includes(md)) return false;
        if (y >= 2026 && md === '10-04') return false;
        if (day === easter(y) + DAY) return false;
      }
      return true;
    };
  }
  function nextWorking(day, working) {
    for (let i = 0; i < 3660; i++, day += DAY) if (working(day)) return day;
    throw new Error('Calendario senza giorni lavorativi validi');
  }
  function deliveryDay(now, days, config) {
    const local = romeParts(now), working = calendar(config);
    let start = local.day;
    const cutoff = (Number.isInteger(config.cutoffHour) ? config.cutoffHour : 14) * 60 + (Number.isInteger(config.cutoffMinute) ? config.cutoffMinute : 0);
    // Il giorno di presa in carico non \u00e8 conteggiato. Alle 14:00 scatta il rinvio.
    if (working(start) && config.cutoffEnabled !== false && local.minutes >= cutoff) start += DAY;
    start = nextWorking(start, working);
    for (let remaining = days; remaining > 0; remaining--) start = nextWorking(start + DAY, working);
    return start;
  }
  function estimate(data, variant, now) {
    if (!variant) return { state: 'select' };
    if (variant.state === 'unavailable') return { state: 'unavailable' };
    if (!['in', 'out'].includes(variant.state)) return { state: 'available' };
    if (!Number.isFinite(now)) return { state: 'available' };
    const today = romeParts(now).day;
    const restock = parseDay(data.restock);
    if (variant.state === 'out' && restock !== null && restock > today) {
      return { state: 'restock', date: nextWorking(restock, calendar(data)) };
    }
    const days = resolveDays(data, variant.state);
    return { state: 'available', date: deliveryDay(now, days, data), days };
  }
  function translations(data) {
    const market = objectJSON(data.marketLanguages)[String(data.market || '').toLowerCase()];
    let locale = String(market || data.locale || 'it').replace(/_/g, '-');
    try { locale = Intl.getCanonicalLocales(locale)[0]; } catch (_) { locale = 'it'; }
    const base = locale.split('-')[0];
    const overrides = objectJSON(data.translations);
    const defaults = TEXTS[base] || TEXTS.en;
    const texts = Object.fromEntries(TEXT_KEYS.map((key, i) => [key, defaults[i]]));
    if (base === 'it') Object.assign(texts, data.italian || {});
    const custom = overrides[locale] || overrides[locale.toLowerCase()] || overrides[base] || {};
    for (const key of TEXT_KEYS) if (typeof custom[key] === 'string' && custom[key].trim()) texts[key] = custom[key];
    return { locale, texts };
  }
  function dateText(day, locale, includeYear) {
    const options = { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' };
    if (includeYear) options.year = 'numeric';
    try { return new Intl.DateTimeFormat(locale, options).format(new Date(day)); }
    catch (_) { return new Intl.DateTimeFormat('en', options).format(new Date(day)); }
  }
  const api = { resolveDays, parseDay, iso, romeParts, easter, calendar, deliveryDay, estimate, translations, dateText };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.document || global.customElements.get('emmeti-delivery')) return;

  // Un solo orologio per pagina. Il tempo avanza con performance.now(), non con
  // l'orologio del dispositivo. Nessuna chiamata a servizi esterni o modifica al carrello.
  const instances = new Set();
  const clock = {
    epoch: null, anchor: 0, pending: null, timer: null, settled: false,
    now() {
      const elapsed = performance.now() - this.anchor;
      return this.epoch !== null && elapsed >= 0 && elapsed < 600000 ? this.epoch + elapsed : NaN;
    },
    sync(root) {
      if (this.pending) return this.pending;
      this.pending = (async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 5000);
        try {
          const url = new URL(`${root || '/'}cart.js`, location.origin);
          url.searchParams.set('_emmeti_clock', String(performance.now()));
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
          const headerDate = Date.parse(response.headers.get('Date') || '');
          const age = Math.max(0, Number(response.headers.get('Age')) || 0);
          if (!response.ok || !Number.isFinite(headerDate)) throw new Error('Ora server assente');
          this.epoch = headerDate + age * 1000;
          this.anchor = performance.now();
          if (response.body) response.body.cancel().catch(() => {});
        } catch (_) {
          // In caso di errore si conserva una sincronizzazione recente; altrimenti
          // si mostra solo la disponibilit\u00e0, senza inventare una data di consegna.
        } finally {
          clearTimeout(timeout);
          this.pending = null;
          this.settled = true;
          instances.forEach(item => item.refresh());
        }
      })();
      return this.pending;
    },
    start(root) {
      if (!this.timer) this.timer = setInterval(() => {
        if (document.hidden) return;
        if (!Number.isFinite(this.now()) || performance.now() - this.anchor > 240000) this.sync(root);
        instances.forEach(item => item.refresh());
      }, 10000);
      if (!Number.isFinite(this.now())) this.sync(root);
    },
    stop() { if (!instances.size) { clearInterval(this.timer); this.timer = null; } }
  };
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && instances.size) {
      clock.epoch = null;
      instances.forEach(item => item.refresh());
      clock.sync(instances.values().next().value.data.root);
    }
  });
  global.addEventListener('pageshow', event => {
    if (event.persisted && instances.size) {
      clock.epoch = null;
      instances.forEach(item => item.refresh());
      clock.sync(instances.values().next().value.data.root);
    }
  });

  class EmmetiDelivery extends HTMLElement {
    connectedCallback() {
      // Gli script defer normalmente arrivano dopo il markup. La microtask
      // consente anche il caricamento tramite l'editor sezioni di Shopify.
      queueMicrotask(() => this.init());
    }
    init() {
      if (this.initialized || !this.isConnected) return;
      try {
        const node = this.querySelector('[data-emmeti-config]');
        if (!node) return;
        this.data = JSON.parse(node.textContent);
        this.scope = this.closest('.js-product') || this.closest('.shopify-section');
        this.view = this.querySelector('[data-emmeti-banner]');
        this.line = this.querySelector('[data-emmeti-line]');
        this.head = this.querySelector('[data-emmeti-head]');
        this.tail = this.querySelector('[data-emmeti-tail]');
        this.meta = this.querySelector('[data-emmeti-meta]');
        this.icon = this.querySelector('[data-emmeti-icon]');
        this.variants = new Map((this.data.variants || []).map(v => [String(v.id), v]));
        if (this.data.selected) this.variants.set(String(this.data.selected.id), this.data.selected);
        const picker = this.scope && this.scope.querySelector('variant-picker');
        const selected = picker && 'variant' in picker ? picker.variant : this.data.selected;
        this.current = selected ? this.variants.get(String(selected.id)) || { id: selected.id, state: selected.available === false ? 'unavailable' : 'unknown' } : null;
        const t = translations(this.data);
        this.locale = t.locale; this.texts = t.texts;
        this.abort = new AbortController();
        this.forms = new Set();
        const options = { signal: this.abort.signal };
        if (this.scope) {
          this.scope.addEventListener('on:variant:change', event => {
            if (event.target.closest('.js-product') !== this.scope) return;
            const selected = event.detail && event.detail.variant;
            this.current = selected ? this.variants.get(String(selected.id)) || { id: selected.id, state: selected.available === false ? 'unavailable' : 'unknown' } : null;
            this.refresh();
          }, options);
          // Capture: aggiorna i campi prima che product-form.js costruisca FormData.
          this.scope.addEventListener('submit', () => this.refresh(), { ...options, capture: true });
        }
        this.initialized = true;
        instances.add(this);
        this.refresh();
        clock.start(this.data.root);
      } catch (error) {
        this.reveal();
        if (global.Shopify && global.Shopify.designMode) console.warn('Tempi di consegna:', error);
      }
    }
    reveal() {
      if (this.hasAttribute('data-emmeti-pending')) this.removeAttribute('data-emmeti-pending');
      if (this.getAttribute('aria-busy') === 'true') this.setAttribute('aria-busy', 'false');
      if (this.emmetiFallbackTimer) {
        clearTimeout(this.emmetiFallbackTimer);
        this.emmetiFallbackTimer = null;
      }
    }
    calculateResult(instant) {
      // Solo lettura: usato anche da formdata, dove modificare il DOM pu\u00f2
      // riattivare gli osservatori dei pulsanti di pagamento e creare un ciclo.
      try { return estimate(this.data, this.current, instant); }
      catch (_) { return { state: this.current && this.current.state === 'unavailable' ? 'unavailable' : this.current ? 'available' : 'select' }; }
    }
    refresh() {
      if (!this.initialized || !this.isConnected) return;
      const instant = clock.now();
      const result = this.calculateResult(instant);
      this.result = result;
      const needsClock = this.current && ['in', 'out'].includes(this.current.state);
      if (this.hasAttribute('data-emmeti-pending') && needsClock && !Number.isFinite(instant) && !clock.settled) {
        // Mantieni il banner invisibile fino al primo tentativo di sincronizzazione.
        // La disponibilit\u00e0 senza data resta il ripiego in caso di errore o timeout.
        this.syncForms();
        return;
      }
      const text = this.texts;
      const head = text[result.state];
      let tail = '';
      if (result.date !== undefined) {
        const yearChanged = new Date(result.date).getUTCFullYear() !== new Date(romeParts(instant).day).getUTCFullYear();
        tail = ` \u2014 ${result.state === 'restock' ? text.dispatch : text.delivery} ${dateText(result.date, this.locale, this.data.showYear || yearChanged)}`;
      }
      if (this.head.textContent !== head) this.head.textContent = head;
      if (this.tail.textContent !== tail) this.tail.textContent = tail;
      if (this.view.dataset.state !== result.state) this.view.dataset.state = result.state;
      const icon = this.data[result.state === 'unavailable' ? 'iconUnavailable' : 'iconAvailable'] || '';
      const iconText = result.state === 'select' ? '' : icon;
      if (this.icon.textContent !== iconText) this.icon.textContent = iconText;
      if (this.icon.hidden !== !iconText) this.icon.hidden = !iconText;
      const info = [];
      if (this.data.showBrand && this.data.vendor) info.push(this.data.vendor);
      if (this.data.showDays && result.days !== undefined) info.push(`${result.days} ${text.days}`);
      if (this.meta.textContent !== info.join(' \u00b7 ')) this.meta.textContent = info.join(' \u00b7 ');
      if (this.meta.hidden !== !info.length) this.meta.hidden = !info.length;
      if (this.lang !== this.locale) this.lang = this.locale;
      this.syncForms();
      // Tutti i nodi sono aggiornati prima che il browser mostri il banner.
      this.reveal();
    }
    propertyValues(result = this.result) {
      if (!this.data.saveProperty || !result || result.date === undefined) return {};
      const dispatch = result.state === 'restock';
      return { [dispatch ? 'Data spedizione stimata' : 'Data consegna stimata']: dateText(result.date, this.locale, true) };
    }
    syncForms() {
      if (!this.scope) return;
      this.scope.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        if (form.closest('.js-product') !== this.scope) return;
        if (!this.forms.has(form)) {
          this.forms.add(form);
          form.addEventListener('formdata', event => {
            // FormData viene letto anche da app e checkout dinamico. Questo
            // evento deve cambiare solo il payload, mai banner o campi del DOM.
            const result = this.calculateResult(clock.now());
            ['Data consegna stimata', 'Data spedizione stimata'].forEach(name => event.formData.delete(`properties[${name}]`));
            Object.entries(this.valuesForForm(form, result)).forEach(([key, value]) => event.formData.set(`properties[${key}]`, value));
          }, { signal: this.abort.signal });
        }
        const values = this.valuesForForm(form);
        for (const key of ['Data consegna stimata', 'Data spedizione stimata']) {
          const name = `properties[${key}]`;
          const fields = [...form.querySelectorAll('input')].filter(input => input.name === name);
          if (!values[key]) { fields.forEach(input => input.remove()); continue; }
          let input = fields.shift();
          fields.forEach(duplicate => duplicate.remove());
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
          if (input.value !== values[key]) input.value = values[key];
          if (input.dataset.emmetiDeliveryProperty !== 'true') input.dataset.emmetiDeliveryProperty = 'true';
        }
      });
    }
    valuesForForm(form, result = this.result) {
      const input = form.querySelector('[name="id"]');
      return this.current && input && String(input.value) === String(this.current.id) ? this.propertyValues(result) : {};
    }
    disconnectedCallback() {
      if (this.emmetiFallbackTimer) {
        clearTimeout(this.emmetiFallbackTimer);
        this.emmetiFallbackTimer = null;
      }
      if (this.abort) this.abort.abort();
      instances.delete(this);
      if (this.forms) this.forms.forEach(form => {
        // Un'altra istanza dello stesso prodotto mantiene il campo condiviso.
        if (![...instances].some(item => item.scope === this.scope)) form.querySelectorAll('[data-emmeti-delivery-property]').forEach(node => node.remove());
      });
      this.initialized = false;
      clock.stop();
    }
  }
  customElements.define('emmeti-delivery', EmmetiDelivery);
})(typeof window !== 'undefined' ? window : globalThis);
